
const values = {};

export default {
    setItem: (key, value) =>  values[key] = value,
    removeItem: (key) => delete values[key],
    getItem: (key)=> values[key],
};
